// extracted by mini-css-extract-plugin
export var addButton = "_ms-0";
export var border = "_ms-8";
export var check = "_ms-h";
export var danger = "_ms-6";
export var dropdownContainer = "_ms-1";
export var editModalBody = "_ms-j";
export var footerContainer = "_ms-i";
export var fullWidth = "_ms-a";
export var hide = "_ms-9";
export var icon = "_ms-3";
export var input = "_ms-7";
export var inputFlex = "_ms-b";
export var inputWrapper = "_ms-c";
export var manualFocus = "_ms-5";
export var optionButton = "_ms-4";
export var pillWrapper = "_ms-e";
export var pointer = "_ms-2";
export var showOverflow = "_ms-f";
export var tagsFlex = "_ms-d";
export var xButton = "_ms-g";